angular.module('webtrader').filter('toColor', () => {
  return (input) => {
    let sum = 0;
    for(let i = 0; i < input.length; i++) sum += input.charCodeAt(i)
    return window.HOT_COLORS[Math.round((sum * 3.1415926535)) % window.HOT_COLORS.length]
  }
})

window.HOT_COLORS = [
  '#2478A5',
  '#6e6b6d',
  '#3B588D',
  '#28760A',
  '#3B588D',
  '#655BA1'
]


angular.module('webtrader').filter('nl2br', ($sanitize) => (msg) => $sanitize(msg.replace(/(\r\n|\n\r|\r|\n|&#10;&#13;|&#13;&#10;|&#10;|&#13;)+/g, '<br />$1')));


angular.module('webtrader').component('setTitle', {
  bindings: {
    name: '@',
  },
  template: ``,
  controller: function ($window) {
    $window.document.title = this.name;
  }
})


export function injectableClass(app, ...injectionsNames) {
  return (klass) => {
    angular.module(app).service(klass.name, injectionsNames.concat((...injections) => {
      for(let i in injectionsNames)
        klass[injectionsNames[i]] = injections[i]
      return klass
    }))
    return klass
  }
}

export function injectableInstance(app, ...injectionsNames) {
  return (klass) => {
    angular.module(app).service(klass.name, injectionsNames.concat((...injections) => {
      let instance = new klass(...injections)
      for(let i in injectionsNames)
        instance[injectionsNames[i]] = injections[i]
      return instance
    }))
    return klass
  }
}

angular.module('webtrader').factory('retryInterceptor', function ($injector, $q, $timeout) {
  return {
    responseError: (response) => {
      let $state = $injector.get('$state')
      if (response.status === 403 && !$state.is('login')) {
        $injector.get('$state').go('login')
        return $q.reject(response)
      }

      if (response.status !== 500 || IS_DEBUG)
        return $q.reject(response)

      response.config.incrementalTimeout = response.config.incrementalTimeout || 0
      if (response.config.incrementalTimeout > 5000)
        return window.location.reload(true)
      response.config.incrementalTimeout += 500

      return $timeout(() => {
        return $injector.get('$http')(response.config);
      }, response.config.incrementalTimeout);
    }
  }
});

angular.module('webtrader').config(function ($httpProvider) {
  $httpProvider.interceptors.push('retryInterceptor')
});


angular.module('webtrader').constant('OPTIONS_LIST', {
  expiration: [1,2,3,4,5,10,15,30],
  volume: [1, 2, 3, 5, 10, 20, 50, 100]
});
